import React, { CSSProperties } from 'react';
import { z } from 'zod';

import { darken, getLuminance, lighten } from '@mui/material';
import { Hr } from '@react-email/hr';
import { useGlobalTextColor } from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';

import defineBlock from './helpers/defineBlock';

export const DividerBlockSchema = defineBlock(
  'Divider',
  z.object({
    lineColor: z.string().nullish(),
    lineHeight: z.number().nullish(),
  })
);

export type TDividerBlock = z.infer<typeof DividerBlockSchema>;

type DividerBlockProps = {
  block: TDividerBlock;
};
export default function DividerBlock({ block }: DividerBlockProps) {
  const globalTextColor = useGlobalTextColor();
  const lineColor =
    block.props?.lineColor ??
    (getLuminance(globalTextColor) > 0.5 ? darken(globalTextColor, 0.8) : lighten(globalTextColor, 0.9));

  const lineHeight = block.props?.lineHeight;
  const style: CSSProperties = {};
  if (lineColor) {
    style.borderColor = lineColor;
  }
  if (typeof lineHeight === 'number') {
    style.borderTopWidth = `${lineHeight}px`;
  }
  return <Hr style={style} />;
}
